<footer id="atomo-footer" class="pt-[72px] md:pt-[68px] lg:pt-[86px] footer w-full">
  <div class="flex flex-col gap-[72px] md:gap-[46px] lg:gap-[105px] items-center justify-center px-4 md:px-14 lg:px-28 bottom_border pb-12 md:pb-6 lg:pb-14" id="subscription-section">

    <div class="grid grid-cols-12 gap-8 md:gap-4 lg:gap-6">
      <!-- Column 1: Logo / About -->
      <div class="col-span-12 md:col-span-3">
        <div class="flex flex-col gap-4 lg:gap-8 md:gap-6">
          <img ngSrc="../../../assets/images/atomo-logo.webp" alt="atomo_logo_with_name" width="100" height="36" priority class="cursor-pointer">
          <div class="flex justify-center items-center">
            <p class="text-grey text-hurrey-16 md:text-hurrey-12 lg:text-hurrey-16" id="atomo_goal">Atomo offers innovative individualized learning by understanding each student for tailored attention. Enhance your child's educational experience with Atomo's precision.</p>
          </div>
        </div>
      </div>

      <!-- Column 2: Quick Links (site-wide pages for SEO) -->
      <div class="col-span-12 md:col-span-3">
        <div class="flex flex-col gap-4 lg:gap-8 md:gap-6">
          <p class="text-black text-hurrey-16 md:text-hurrey-20 lg:text-hurrey-36">Quick Links</p>
          <div class="flex flex-col gap-2 md:gap-4 lg:gap-6">
            <a class="text-grey text-hurrey-16 md:text-hurrey-12 lg:text-hurrey-16 hover:underline" href="/">Home</a>
            <a class="text-grey text-hurrey-16 md:text-hurrey-12 lg:text-hurrey-16 hover:underline" href="/use-cases">Use Cases</a>
            <a class="text-grey text-hurrey-16 md:text-hurrey-12 lg:text-hurrey-16 hover:underline" href="/contact-us">Contact Us</a>
            <a class="text-grey text-hurrey-16 md:text-hurrey-12 lg:text-hurrey-16 hover:underline" href="/products">All Products</a>
            <a class="text-grey text-hurrey-16 md:text-hurrey-12 lg:text-hurrey-16 hover:underline" href="/about-us">About Us</a>
            <!-- <a class="text-grey text-hurrey-16 md:text-hurrey-12 lg:text-hurrey-16 hover:underline" href="/join-us">Careers</a> -->
            <a class="text-grey text-hurrey-16 md:text-hurrey-12 lg:text-hurrey-16 hover:underline" href="/blogs">Blogs</a>
            <a class="text-grey text-hurrey-16 md:text-hurrey-12 lg:text-hurrey-16 hover:underline" href="/reseller">Reseller</a>
            <a class="text-grey text-hurrey-16 md:text-hurrey-12 lg:text-hurrey-16 hover:underline" href="/waitlist">Waitlist</a>
            <a class="text-grey text-hurrey-16 md:text-hurrey-12 lg:text-hurrey-16 hover:underline" href="/our-initiatives">Our Initiatives</a>
            <!-- <a class="text-grey text-hurrey-16 md:text-hurrey-12 lg:text-hurrey-16 hover:underline" href="/education_but_cooler">Campaign</a> -->
          </div>
        </div>
      </div>

      <!-- Column 3: Products -->
      <div class="col-span-12 md:col-span-3">
        <div class="flex flex-col gap-4 lg:gap-8 md:gap-6">
          <p class="text-black text-hurrey-16 md:text-hurrey-20 lg:text-hurrey-36">Products</p>
          <div class="flex flex-col gap-2 md:gap-4 lg:gap-6">
            <a class="text-grey text-hurrey-16 md:text-hurrey-12 lg:text-hurrey-16 hover:underline" href="/math-solver">Math Solver</a>
            <a class="text-grey text-hurrey-16 md:text-hurrey-12 lg:text-hurrey-16 hover:underline" href="/hurrey-scope">Hurrey Scope</a>
            <a class="text-grey text-hurrey-16 md:text-hurrey-12 lg:text-hurrey-16 hover:underline" href="/language-learner">Language Learner</a>
            <a class="text-grey text-hurrey-16 md:text-hurrey-12 lg:text-hurrey-16 hover:underline" href="/physics-solver">Physics Solver</a>
          </div>
        </div>
      </div>

      <!-- Column 4: Social (desktop) -->
      <div class="col-span-12 md:col-span-3 hidden md:flex">
        <div class="flex flex-col gap-4 md:gap-6 lg:gap-8 items-start">
          <p class="text-black text-hurrey-16 md:text-hurrey-20 lg:text-hurrey-36">Social</p>
          <div class="flex gap-2 items-center">
            <a href="https://www.linkedin.com/company/atomoclass" target="_blank" rel="noopener noreferrer nofollow" title="Visit Atomo's LinkedIn Page">
              <img src="../../../assets/icons/linkedIn.svg" alt="linkedIn" width="24" height="24">
            </a>
            <a href="https://www.youtube.com/channel/UC8vP8aLgjJA3D67Wsl1_Z4g" target="_blank" rel="noopener noreferrer nofollow" title="Visit Atomo's YouTube channel">
              <img src="../../../assets/icons/youtube.svg" alt="youtube" width="24" height="24">
            </a>
            <a href="https://www.facebook.com/profile.php?id=61569609287836" target="_blank" rel="noopener noreferrer nofollow" title="Visit Atomo's Facebook Page">
              <img src="../../../assets/icons/fb_logo.svg" alt="facebook" width="24" height="24">
            </a>
            <a href="https://www.instagram.com/theatomoai/" target="_blank" rel="noopener noreferrer nofollow" title="Visit Atomo's Instagram Page">
              <img src="../../../assets/icons/insta_logo.svg" alt="instagram" width="24" height="24">
            </a>
            <a href="https://x.com/theatomoai" target="_blank" rel="noopener noreferrer nofollow" title="Visit Atomo's Page on X">
              <img src="../../../assets/icons/x-logo.svg" alt="X" width="24" height="24">
            </a>
          </div>
          <div class="hidden md:block">
            <p class="text-grey text-hurrey-16 md:text-hurrey-12 lg:text-hurrey-16">Atomo is recognized as Top 5 ‘Most Innovative Startups’ by ET Innovation Awards 2020.</p>
          </div>
        </div>
      </div>

      <!-- Mobile: social row -->
      <div class="md:hidden col-span-12">
        <div class="flex flex-col gap-4 md:gap-6 lg:gap-8">
          <p class="text-black text-hurrey-16 md:text-hurrey-20 lg:text-hurrey-36">Social</p>
          <div class="flex gap-2 items-center">
            <a href="https://www.linkedin.com/company/atomoclass" target="_blank" rel="noopener noreferrer nofollow" title="Visit Atomo's LinkedIn Page">
              <img src="../../../assets/icons/linkedIn.svg" alt="linkedIn" width="24" height="24">
            </a>
            <a href="https://www.youtube.com/channel/UC8vP8aLgjJA3D67Wsl1_Z4g" target="_blank" rel="noopener noreferrer nofollow" title="Visit Atomo's YouTube channel">
              <img src="../../../assets/icons/youtube.svg" alt="youtube" width="24" height="24">
            </a>
            <a href="https://www.facebook.com/profile.php?id=61569609287836" target="_blank" rel="noopener noreferrer nofollow" title="Visit Atomo's Facebook Page">
              <img src="../../../assets/icons/fb_logo.svg" alt="facebook" width="24" height="24">
            </a>
            <a href="https://www.instagram.com/theatomoai/" target="_blank" rel="noopener noreferrer nofollow" title="Visit Atomo's Instagram Page">
              <img src="../../../assets/icons/insta_logo.svg" alt="instagram" width="24" height="24">
            </a>
            <a href="https://x.com/theatomoai" target="_blank" rel="noopener noreferrer nofollow" title="Visit Atomo's Page on X">
              <img src="../../../assets/icons/x-logo.svg" alt="X" width="24" height="24">
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Bottom: copyright + legal links + small social -->
  <div class="px-10 md:px-12 lg:px-24 gap-4 py-3 md:py-3 lg:py-6">
    <div class="flex flex-col md:flex-row items-center justify-between gap-4">
      <p class="text-hurrey-12 text-grey text-center">Copyright &#169; 2024-2025, Apeiros Eduventures Pvt. Ltd.</p>

      <div class="flex flex-col md:flex-row items-center gap-4">
        <a class="text-hurrey-12 text-grey underline" href="/privacy-policy">Privacy Policy</a>
        <a class="text-hurrey-12 text-grey underline" href="/terms-and-conditions">Terms of Use</a>
        <a class="text-hurrey-12 text-grey underline" href="/disclaimer">Disclaimer</a>
      </div>

      <div class="flex gap-2 items-center">
        <a href="https://www.linkedin.com/company/atomoclass" target="_blank" rel="noopener noreferrer nofollow" title="Visit Atomo's LinkedIn Page">
          <img src="../../../assets/icons/linkedIn.svg" alt="linkedIn" width="16" height="16">
        </a>
        <a href="https://www.youtube.com/channel/UC8vP8aLgjJA3D67Wsl1_Z4g" target="_blank" rel="noopener noreferrer nofollow" title="Visit Atomo's YouTube channel">
          <img src="../../../assets/icons/youtube.svg" alt="youtube" width="16" height="16">
        </a>
        <a href="https://www.facebook.com/profile.php?id=61569609287836" target="_blank" rel="noopener noreferrer nofollow" title="Visit Atomo's Facebook Page">
          <img src="../../../assets/icons/fb_logo.svg" alt="facebook" width="16" height="16">
        </a>
        <a href="https://www.instagram.com/theatomoai/" target="_blank" rel="noopener noreferrer nofollow" title="Visit Atomo's Instagram Page">
          <img src="../../../assets/icons/insta_logo.svg" alt="instagram" width="16" height="16">
        </a>
        <a href="https://x.com/theatomoai" target="_blank" rel="noopener noreferrer nofollow" title="Visit Atomo's Page on X">
          <img src="../../../assets/icons/x-logo.svg" alt="X" width="16" height="16">
        </a>
      </div>
    </div>
  </div>
</footer>
